import { PatternFormatProps, patternFormatter } from 'react-number-format';

const DEFAULT_FORMAT = '(###) ###-####';

export const DEFAULT_PHONE_LENGTH = 10;

type FormatProps = Omit<PatternFormatProps, 'format'> & {
  format?: string;
  displayDialCode?: boolean;
};

export const preparePhoneValue = (value: string): string => value
  .replace(/\D+/g, '')
  .slice(-DEFAULT_PHONE_LENGTH);

export const isValidPhoneNumber = (value: string | undefined): value is string => preparePhoneValue(value || '').length >= DEFAULT_PHONE_LENGTH;

export const getPhoneFormat = (value: string, format: string = DEFAULT_FORMAT, displayDialCode: boolean = false) => {
  const phone = value.replace(/\D+/g, '');

  if (displayDialCode && phone.length > DEFAULT_PHONE_LENGTH) {
    const code = phone.substring(0, phone.length - DEFAULT_PHONE_LENGTH);
    return `+${code} ${DEFAULT_FORMAT}`;
  }

  return format;
};

export const formatPhoneNumber = (value: string, props: FormatProps) => {
  const { format, displayDialCode, ...rest } = props;

  const phoneFormat = getPhoneFormat(value, format, displayDialCode);

  return patternFormatter(preparePhoneValue(value), {
    format: phoneFormat,
    ...rest,
  });
};
